import { Link } from "react-router-dom";
import { convertDate } from "utils/helpers";

const BOX_SECTION_TITLES = {
  none: "none (wózek box_1)",
  box_4: "box_4",
  box_6: "box_6",
  box_12: "box_12",
  box_24: "box_24",
  heavy: "heavy (wózek)",
};

/** Dla tych rozmiarów pak = 1 GDN — przyciski tworzenia przy wierszu, nie w nagłówku. */
const PER_ROW_ACTION_BOX_KEYS = ["none", "heavy"];

const sectionTitle = (box_key) => BOX_SECTION_TITLES[box_key] || box_key;

const rowDueTodayStyle = (dispatch_due_today) =>
  dispatch_due_today ? { backgroundColor: "rgba(244, 67, 54, 0.12)" } : undefined;

const GdnCartBox = ({ box_key, rows, setModalConfig }) => {
  const per_row_actions = PER_ROW_ACTION_BOX_KEYS.includes(box_key);
  const col_count = per_row_actions ? 10 : 9;

  return (
    <section className="dashboard m-b-20" key={box_key}>
      <div className="dashboard__header">
        <h3 className="dashboard__title heading m-l-0">
          {sectionTitle(box_key)}{" "}
          <span style={{ fontWeight: 400, opacity: 0.85 }}>
            ({rows.length})
          </span>
        </h3>
        {!per_row_actions && (
          <div>
            <button
              type="button"
              className="btn btn-sm btn-green m-r-10"
              onClick={() =>
                setModalConfig({ cart_box_size: box_key, dispatch_due_today: false })
              }
            >
              Utwórz paka dla wszystkich zamówień
            </button>
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() =>
                setModalConfig({ cart_box_size: box_key, dispatch_due_today: true })
              }
            >
              Utwórz paka dla zamówień dzisiejszych
            </button>
          </div>
        )}
      </div>
      <table className="table table-sm">
        <thead className="table__header">
          <tr>
            <th>OMS ID</th>
            <th>Numer</th>
            <th>Tryb pojedynczy</th>
            <th>Kanał</th>
            <th>Data utw.</th>
            <th>Wysłać do</th>
            <th>Ilość produktów</th>
            <th>Liczba pozycji</th>
            <th>Metoda dostawy</th>
            {per_row_actions && <th style={{ width: "150px", whiteSpace: "nowrap" }}>Akcje</th>}
          </tr>
        </thead>
        <tbody className="table__body">
          {rows.length === 0 ? (
            <tr>
              <td colSpan={col_count}>Brak zamówień</td>
            </tr>
          ) : (
            rows.map(
              ({
                id,
                expano_oms_id,
                prepared_at,
                delivery_method_name,
                channel,
                single_picking_mode,
                delivery_dispatch_to,
                dispatch_due_today,
                gdn_lines_total_quantity,
                gdn_lines_total_count,
              }) => (
                <tr key={id} style={rowDueTodayStyle(dispatch_due_today)}>
                  <td>
                    <a
                      className="link"
                      href={`https://tradesk.pl/oms/orders?detail=%22${expano_oms_id}%22`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {expano_oms_id}
                    </a>
                  </td>
                  <td>
                    <Link className="link" to={`/gdns/${id}`}>
                      {id}
                    </Link>
                  </td>
                  <td>{single_picking_mode ? "tak" : "nie"}</td>
                  <td>{channel?.identifier}</td>
                  <td>{convertDate({ value: prepared_at })} </td>
                  <td>
                    {delivery_dispatch_to
                      ? convertDate({ value: delivery_dispatch_to })
                      : "—"}
                  </td>
                  <td>{gdn_lines_total_quantity ?? "—"}</td>
                  <td>{gdn_lines_total_count ?? "—"}</td>
                  <td>{delivery_method_name}</td>
                  {per_row_actions && (
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-green"
                        onClick={() =>
                          setModalConfig({
                            cart_box_size: box_key,
                            dispatch_due_today: false,
                            gdn_id: id,
                            expano_oms_id,
                          })
                        }
                      >
                        Utwórz paka
                      </button>
                    </td>
                  )}
                </tr>
              ),
            )
          )}
        </tbody>
      </table>
    </section>
  );
};

export default GdnCartBox;
